<div class="sidebar">
  <app-sidebar-header
    [title]="INDRA_getTitle()"
    [label]="INDRA_getSubTitle('from', 'perItem') | ibeadmin : 'sync'"
  >
    <div actions>
      <button
        class="button button--small"
        [disabled]="INDRA_checkMiles()"
        (click)="
          !isModificationDisallowed
            ? INDRA_processAncillary()
            : INDRA_closeSidebar()
        "
        *ngIf="
          !isServiceLoading &&
          (INDRA_hasAddedAncillaries() || addedAncillary.length != 0)
        "
        [attr.aria-label]="
          INDRA_getAriaLabelTranslation('confirmChanges') | ibeadmin : 'sync'
        "
      >
        {{ INDRA_getTextTranslation("done") | ibeadmin : "sync" }}
      </button>
    </div>
  </app-sidebar-header>

  <div #sidebar__body class="sidebar__body sl--scrollable">
    <app-flight-route [flight]="flightRouteInput"></app-flight-route>

    <ng-container *ngIf="stops && stops.length > 1">
      <app-segmented-control-radio
        classes="sidebar__info--flight-info--options"
        (selected)="INDRA_selectedStop($event)"
        [_value]="selectedStop"
        [options]="stops"
      >
      </app-segmented-control-radio>
    </ng-container>

    <!-- LOADING -->
    <app-loading *ngIf="isServiceLoading"></app-loading>

    <ng-container *ngIf="!isServiceLoading">
      <div #sidebar__info>
        <!-- Ancillary Selection Error -->
        <div *ngIf="selectionApiError" class="extras__helper-notification">
          <app-notification
            [style]="'alert'"
            [classes]="'alert-sidebar'"
            [icon]="'icons.svg#airport--delays'"
            [title]="INDRA_getOperationErrorNotificationTitle()"
          >
            <div message>
              {{
                "cancelBooking.text.atThisMomentThisOperationCanNotBeDoneSorryByTheInconvenience"
                  | ibeadmin : "sync"
              }}
            </div>
          </app-notification>
        </div>
      </div>
      <div #sidebar__info class="sidebar__info sidebar__info--columns">
        <div class="sidebar__info-text">
          <ul class="vantages-listing">
            <li>
              {{ INDRA_getTextTranslation("priority") | ibeadmin : "sync" }};
            </li>
            <li>
              {{
                INDRA_getTextTranslation("avoidWaiting") | ibeadmin : "sync"
              }};
            </li>
          </ul>
          <a
            class="link link--external"
            (click)="INDRA_gotoURL('externalURLs.aboutFastTrack')"
            href="javascript:;"
            [attr.aria-label]="
              INDRA_getAriaLabelTranslation('openDialog') | ibeadmin : 'sync'
            "
            >{{
              INDRA_getTextTranslation("moreAboutFastTrack") | ibeadmin : "sync"
            }}</a
          >
        </div>
        <!-- <div
          class="sidebar__info-image"
          [style.background-image]="
            'url(assets/images/ancillaries/brand-extras/fasttrack--small.jpg)'
          "
        ></div> -->
      </div>
      <div class="flight">
        <div class="divider"></div>
        <ng-container
          class="passenger"
          *ngFor="
            let passenger of passengers;
            let passenger_index = index;
            let first = first
          "
        >
          <div
            class="passenger"
            *ngIf="
              INDRA_isElegibleWithFastTrack(passenger.idPax) ||
              (!INDRA_isElegibleWithFastTrack(passenger.idPax) && first)
            "
          >
            <ng-container
              *ngIf="INDRA_isElegibleWithFastTrack(passenger.idPax)"
            >
              <div class="passenger__details">
                <h3 class="title-h3 passenger__name">
                  {{ INDRA_printPassengerName(passenger) }}
                </h3>
              </div>
              <div
                class="passenger__actions"
                *ngIf="
                  passenger?.tierLevelFF &&
                  INDRA_isPassengerPresentOnTierLevel([passenger])
                "
              >
                <div class="passenger__action included">
                  <p>
                    {{ INDRA_getTitle() }}
                    {{
                      INDRA_getTextTranslation("tapAndMiles")
                        | ibeadmin : "sync"
                    }}
                    {{
                      INDRA_getTextTranslation(passenger?.tierLevelFF)
                        | ibeadmin : "sync"
                    }}
                    {{
                      INDRA_getTextTranslation("benefit") | ibeadmin : "sync"
                    }}
                  </p>
                </div>
              </div>
              <div class="passenger__actions">
                <div
                  class="passenger__action"
                  *ngIf="
                    INDRA_hasActiveAncillaryOnSegment(
                      passenger.idPax,
                      flightStop.idInfoSegment
                    )
                  "
                >
                  <button
                    class="button button-secondary button--icon-right"
                    (click)="
                      !isModificationDisallowed
                        ? INDRA_removeAncillary(passenger)
                        : return
                    "
                    role="alert"
                    aria-label="INDRA_printAddedButtonLabel(passenger.idPax)"
                  >
                    {{ INDRA_printAddedButtonLabel(passenger.idPax) }}
                    {{ INDRA_getTextTranslation("added") | ibeadmin : "sync" }}
                    <app-svg
                      aria-hidden="true"
                      svg="icons.svg#general--check"
                      [alt]="'Checked icon'"
                    ></app-svg>
                    <span class="extra-price"
                      >({{
                        INDRA_printRemoveButtonLabel(passenger.idPax)
                          | indracurrency
                      }})</span
                    >
                  </button>
                  <app-svg
                    [ngClass]="['remove-extra']"
                    [attr.aria-label]="
                      INDRA_getAriaLabelTranslation('removeFastTrack')
                        | ibeadmin : 'sync'
                    "
                    (click)="INDRA_removeAncillary(passenger)"
                    svg="icons.svg#general--close"
                    aria-hidden="true"
                    [alt]="'Remove icon'"
                    *ngIf="!isModificationDisallowed"
                  >
                  </app-svg>
                </div>
                <div
                  class="passenger__action"
                  *ngIf="
                    !INDRA_hasActiveAncillaryOnSegment(
                      passenger.idPax,
                      flightStop.idInfoSegment
                    ) > 0 && !isModificationDisallowed
                  "
                >
                  <button
                    class="button"
                    aria-label="INDRA_printAddButtonLabel(passenger.idPax)"
                    (click)="INDRA_addAncillary(passenger)"
                  >
                    {{ INDRA_getTextTranslation("add") | ibeadmin : "sync" }}
                    {{ INDRA_printAddButtonLabel(passenger.idPax) }}
                  </button>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="INDRA_checkAncillaryInPack()">
              <div class="passenger__action">
                  <button
                    class="button button-secondary button--icon-right"
                    role="alert"
                    aria-label="INDRA_printAddedButtonLabel(passenger.idPax)"
                  >
                    {{ 'addMoreSidebars.pack.texts.includedInPack' | ibeadmin | async }}
                    <app-svg
                      aria-hidden="true"
                      svg="icons.svg#general--check"
                      [alt]="'Checked icon'"
                    ></app-svg>
                  </button>
                </div>
            </ng-container>
            <ng-container
              *ngIf="!INDRA_isElegibleWithFastTrack(passenger.idPax) && !INDRA_checkAncillaryInPack()"
            >
              <div class="warning-banner">
                <app-svg
                  class="warning-icon"
                  svg="icons.svg#general--information"
                  aria-hidden="true"
                  [alt]="'Warning icon'"
                ></app-svg>
                {{
                  INDRA_getTextTranslation("notAvailableFrom")
                    | ibeadmin : "sync"
                }}
                {{ INDRA_getLocation(flightStop.departureAirport) }}
                {{ INDRA_getTextTranslation("to") | ibeadmin : "sync" }}
                {{ INDRA_getLocation(flightStop.arrivalAirport) }}.
              </div>
            </ng-container>
          </div>
        </ng-container>
        <div
          class="extras__helper with-notification"
          *ngIf="
            (notificationShowing ||
              (INDRA_checkOtherFlightAncillaries() &&
                INDRA_hasAddedAncillaries())) &&
            !isModificationDisallowed
          "
        >
          <!-- IBETPIDOS-8850 : Removed "Apply the same to other flights" link
          <div class="extras__helper-actionable">
            <a
              class="link"
              (click)="INDRA_handleApplyAll()"
              title="{{
                INDRA_getTitleTranslation('INDRA_getTitleTranslation')
                  | ibeadmin : 'sync'
              }}"
              href="javascript:;"
              role="button"
            >
              {{
                INDRA_getTextTranslation("applySameToOtherFlights")
                  | ibeadmin : "sync"
              }}</a
            >
          </div>
          -->
          <div
            #sidebar__notification
            class="extras__helper-notification"
            role="status"
            tabindex="0"
            [class.is-showing]="notificationShowing"
            [attr.aria-hidden]="!notificationShowing"
          >
            {{ notificationMessage }}
          </div>
        </div>

        <div class="sidebar__payment_totals">
          <div
            class="total"
            *ngIf="
              INDRA_hasAddedAncillaries() &&
              INDRA_printTotalPerSegment(flightStop.idInfoSegment)
            "
          >
            <label
              class="label"
              *ngIf="
                INDRA_printItemsCountPerSegment(flightStop.idInfoSegment) == 1
              "
              >{{ INDRA_printItemsCountPerSegment(flightStop.idInfoSegment) }}
              {{ INDRA_getTextTranslation("item") | ibeadmin : "sync" }}</label
            >
            <label
              class="label"
              *ngIf="
                INDRA_printItemsCountPerSegment(flightStop.idInfoSegment) > 1
              "
              >{{ INDRA_printItemsCountPerSegment(flightStop.idInfoSegment) }}
              {{ INDRA_getTextTranslation("items") | ibeadmin : "sync" }}</label
            >
            <p class="value">
              {{
                INDRA_printTotalPerSegment(flightStop.idInfoSegment)
                  | indracurrency
              }}
            </p>
          </div>

          <app-extras-sidebar-miles-info
            *ngIf="!isModificationDisallowed"
            [milesNeeded]="milesNeeded"
            [addedAncillary]="addedAncillary"
            [payExtrasWithMiles]="payWithMiles"
            [notEnoughMilesFlag]="notEnoughMilesFlag"
            [hasAddedExtrasFlag]="hasAddedExtrasFlag"
            (isChecked)="INDRA_payAncillaryWithMiles($event)"
          >
          </app-extras-sidebar-miles-info>

          <div class="flow_actions" *ngIf="INDRA_hasAddedAncillaries()">
            <!-- IBETPIDOS-8890: Remove "Select for next flight button" -->
            <!-- <app-flights-navigation
              [ancillaryType]="ancillariesType"
            ></app-flights-navigation> -->
          </div>

          <div
            class="flow_actions"
            [ngClass]="INDRA_flowActionsClasses()"
            *ngIf="
              (INDRA_hasAddedAncillaries() || addedAncillary.length != 0) &&
              !isModificationDisallowed
            "
          >
            <!--
              <button class="button"
              (click)="INDRA_handleNext()"
              [attr.aria-label]="INDRA_getAriaLabelTranslation('selectNextFlight') | ibeadmin:'sync'"
              *ngIf="INDRA_hasNextFlight()">
              {{ INDRA_getTextTranslation('selectNextFlight') | ibeadmin: 'sync' }}
              </button>
            -->
            <button
              class="button"
              [disabled]="INDRA_checkMiles()"
              (click)="INDRA_processAncillary()"
              [attr.aria-label]="
                INDRA_getAriaLabelTranslation('closeDialog') | ibeadmin : 'sync'
              "
            >
              {{ INDRA_getTextTranslation("done") | ibeadmin : "sync" }}
            </button>
          </div>
        </div>

        <div class="sidebar-flight-text top-gap" *ngIf="!isMYB">
          <p>
            {{
              INDRA_getTextTranslation("milesAndGoFreeFastTrack")
                | ibeadmin : "sync"
            }}
          </p>
          <p>
            {{
              INDRA_getTextTranslation("fasTrackFreePerk") | ibeadmin : "sync"
            }}
          </p>
        </div>

        <div class="conditions">
          <h3 class="title-h3 conditions__title">
            {{ INDRA_getTitleTranslation("conditions") | ibeadmin : "sync" }}
          </h3>
          <div class="conditions__text">
            <div class="grid">
              <div class="col-12">
                <ul class="bullet-list">
                  <li>
                    {{
                      INDRA_getTextTranslation("notTransferable")
                        | ibeadmin : "sync"
                    }}
                  </li>
                  <li>
                    {{
                      INDRA_getTextTranslation("notChangeable")
                        | ibeadmin : "sync"
                    }}
                  </li>
                  <li>
                    {{
                      INDRA_getTextTranslation("availableForFlight")
                        | ibeadmin : "sync"
                    }}
                  </li>
                  <li>
                    {{
                      INDRA_getTextTranslation("availableForHours")
                        | ibeadmin : "sync"
                    }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <a
            class="link link--external"
            href="javascript:;"
            (click)="INDRA_gotoURL('externalURLs.aboutFastTrack')"
          >
            {{
              INDRA_getTextTranslation("allTermsAndConditions")
                | ibeadmin : "sync"
            }}
          </a>
        </div>
      </div>
    </ng-container>
    <div #sidebar__footer class="sidebar__footer"></div>
  </div>
</div>

